const zh = {
  copySuccess: '地址复制成功',
  copyError: '复制失败，请重试！',
  noRecord: '暂无记录',
  color: '颜色',
  price: '价格',
  time: '时间',
  success: '成功',
  fail: '失败',
  titleText: '天空之城俱乐部',
  copy: '复制地址',
  balance: '余额',
  buy: '购买',
  loadingText: '加载中...',
  connectText: `请确定是否安装{wallet}?`,
  lastPage: '没有上一页了',
  nextPage: '没有下一页了',
  notOpen: '暂未开放',
  name: '茅草屋',
  notIn: '未达到销售预期',
  enter: '进入DAPP',
  information: '社交媒体',
  loveText: '您已完成点赞！',
  skytBal: 'SKYT余额不足!',
  usdtBal: 'USDT余额不足!',
  withdraw: '提现',
  Nav: {
    home: '首页',
    market: '市场',
    nft: '我的NFT',
    exchange: '兑换',
    account: '我的账户',
    connect: '连接钱包',
    pledge: '质押',
  },
  Account: {
    title: '我的账户',
    title2: '我的邀请',
    inviteTitle: '邀请好友',
    bindSuccess: '绑定成功',
    bindTitle: '绑定上级',
    copy: '复制链接',
    bind: '绑定',
    bindIng: '绑定中...',
    assets: '总资产',
    address: '请输入上级地址',
    total: '交易收益',
    income: '邀请返佣',
    parent: '上级',
    bindBtn: '填写邀请地址',
    invitePerson: '推广人数',
    invite: '邀请',
    record1: '收益日志',
    record2: '我的伙伴',
    code: '邀请码：',
    parentAlert: '请先绑定上级！',
    nav: {
      one: '收益类型',
      two: '收益',
      three: '出售',
      four: '推广',
      five: '地址',
      six: '注册时间',
      seven: '本金',
    },
  },
  Swap: {
    number: '请输入兑换数量',
    btn: '兑换',
    type1: `{usdt} USDT 兑换 {token} SKYT`,
    type2: `{token} SKYT 兑换 {usdt} USDT`,
  },
  AccountTransfer: {
    link: '在BSC浏览器上查看',
    transfer: '最近的交易',
    clear: '(全部清除)',
    account: '账户',
    record: '您的交易将会出现在这里...',
  },
  HashType: {
    one: '购买LAND',
    two: '出售LAND',
    three: 'USDT 兑换 SKYT',
    four: 'SKYT 兑换 USDT',
    five: '修改LAND',
    six: '取消LAND',
  },
  SwapAlert: {
    title1: '用户兑换',
    title2: '用户取消',
    title3: '用户交易',
    title4: '用户修改',
    title5: '用户购买',
    title6: '用户上架',
    success1: '兑换成功',
    success2: '取消成功',
    success3: '交易成功',
    success4: '修改成功',
    btn1: '兑换中...',
    btn2: '取消中...',
    btn3: '交易中...',
    btn4: '修改中...',
    close: '关闭',
  },
  PixelItem: {},
  EmpowerAlert: {
    one: `允许Market调用您的 #{tokenId} NFT`,
    two: '允许Market合约调用您的USDT',
    three: '允许NFT合约调用您的SKYT',
    four: '允许Market合约调用您的SKYT',
    btn1: '授权中...',
    btn2: '授权NFT',
    btn3: '授权USDT',
    btn4: '授权SKYT',
    title: '用户授权',
  },

  Home: {
    title: '铸造LAND',
    title1: '视频',
    title2: '合作伙伴',
    text1: '天空之城',
    text2:
      '《Cityinthesky》元宇宙由LAND构成，持有LAND的玩家可用它来进行创作，并赚取收益。可用LAND的数量永远为90,000块，它们可用来举办游戏、打造多人游戏体验、建造房屋，或为社区提供社交体验.',
    text3: '20天空之城画家',
    text4: '选择一种颜色',
    text5: '1.选择要绘制的像素',
    text6: '欢迎光临',
    text7: '天空之城俱乐部',
    text8:
      '古老帝国拉比达是一座漂浮在空中的巨大的机器岛，传说那里已经无人居住，蕴藏着巨大的财富。因此，无论军方还是海盗，都在找寻着这座传说中的飞行岛。矿工帕克这天偶遇拉比达继承人希达，两人一见如故。因为希达身上有找寻拉比达帝国的重要物件飞行石，军方和海盗两帮人马都在追杀希达。帕克带着希达一起逃亡，最终都没有逃出军方的手中，希达被军队掳走了。为救朋友，帕克只能选择与海盗合作。帕克与海盗成功救出了希达，同时，他们也发现了军方的邪恶计划。为了阻止军方邪恶计划的实施，他们和海盗一起踏上了寻找拉比达之旅。',
    text9: '进入市场',
    text10: '什么是NFT？',
    text11:
      '非同质化代币（NFT）是一种储存在区块链上的虚拟代币，具有数字稀缺性丶安全性和真实性等特点。它们独一无二丶不可分割，且无法互换，能让游戏内资产真正拥有数字所有权。',
    text12: `用户{start}...{end}正在购买NFT`,
    text13:
      '在《Cityintehsky》的虚拟元宇宙里，玩家可以游玩丶打造丶拥有，并使用虚拟体验获取收益。你可以将你的加密货币用于投资，获取更多GOLD',
    alert1: '请先选择像素块',
    alert2: '已全部铸造完毕!',
    alert3: '铸造数量已满！',
    btn1: '购买LAND',
    btn2: '立即质押',
    likes: '点赞',
  },
  Market: {
    text: '古老帝国拉比达是一座漂浮在空中的巨大的机器岛，传说那里已经无人居住，蕴藏着巨大的财富。因此，无论军方还是海盗，都在找寻着这座传说中的飞行岛。矿工帕克这天偶遇拉比达继承人希达，两人一见如故。因为希达身上有找寻拉比达帝国的重要物件飞行石，军方和海盗两帮人马都在追杀希达。帕克带着希达一起逃亡，最终都没有逃出军方的手中，希达被军队掳走了。为救朋友，帕克只能选择与海盗合作。帕克与海盗成功救出了希达，同时，他们也发现了军方的邪恶计划。为了阻止军方邪恶计划的实施，他们和海盗一起踏上了寻找拉比达之旅',
    nav: {
      one: '商品',
      two: '地板价',
      three: '最新成交价',
      four: '购买者',
      five: '交易时间',
    },
    alert: '不能购买自己的单子！',
    seller: '所有者',
    seeMore: '阅读更多',
    down: '收起',
    record: '记录',
    type1: '时间排序',
    type2: '价格排序',
  },
  NFT: {
    tabs: {
      one: '持有中',
      two: '出售中',
      three: '已购买',
    },
    type1: `用户{start}...{end}正在上架#{tokenId}NFT`,
    type2: `用户{start}...{end}正在取消上架#{tokenId}NFT`,
    type3: `用户{start}...{end}正在修改#{tokenId}NFT`,
    changeColor: '选择替换的颜色',
    modity: '确认修改',
    notice: '出售时平台会抽取8%的手续费',
    cancel: '取消出售',
    sell: '出售',
    notSell: '可参与质押',
    moditySuccess: '修改成功',
    counts: '成交次数:',
  },
  Propaganda: {
    text1:
      ' 每个 NFT房屋都是独一无二的，并以编程方式从170种可能的特征中生成，包括屋顶、树木、门窗等。',
    text2:
      '所有房屋都很厉害，但有些比其他人更罕见。所有NFT均存储在BSC区块链上并托管在 IPFS 上。',
  },
};

export default zh;
